import {forwardRef, Injectable, Inject} from '@angular/core';
import {PollingBaseService} from '../models/polling-base-service.model';
import {Utilities} from '../utilities/utilities.model';
import {Observable} from 'rxjs/Observable';
import {HttpAuthService} from './http-auth.service';
import {isNumber} from 'util';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {UserV3Service} from '@shared/service/user-v-3.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {of} from 'rxjs';

@Injectable()
export class OrderAlertsDashboardPollingService extends PollingBaseService {

    environment: AppConfigEnvironment;

	constructor(@Inject(forwardRef(() => HttpAuthService)) public httpAuthService: HttpAuthService,
				public userV3Service: UserV3Service,
                private appConfig: AppConfigEnvironmentService,
				public selectCommoditiesService: SelectCommoditiesService) {
		super();
    this.environment = appConfig.Environment;
	}

	settingPolling() {
		this.startPolling();
	}

	doAction() {
		this.getNewAlertsStats()
			.subscribe((itemsCount: number) => {
				this.lastResult = (itemsCount > 0) ? itemsCount : 0;
				this.pollingSubject.next(this.lastResult);
			});
	}

	getNewAlertsStats(): Observable<number> {
		const newer_than = this.userV3Service.getAlertsLastAccess();
		const txt_sender_search = this.userV3Service.getCurrentUser().id;
		const url: string = this.environment.GW_API + '/alerts/stats?newer_than=' + newer_than + '&txt_sender_search=!' + txt_sender_search;
		const options = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());

		return this.selectCommoditiesService.getAldCommodityIds().length>0 ? new Observable<number>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {
							let value = response.json().itemsCount;
							if (!isNumber(value)) {
								value = Number.parseInt(value);
								if (isNaN(value)) {
									value = -1;
								}
							}
							observer.next(value);
						} else {
							observer.next(-1);
						}
					},
					error => {
						console.error(error);
						observer.next(-1);
					});
			}) : of(0);
	}
}
